import { Dispatch } from 'redux';

import { IAppState, TActions } from '../../common/state';
import { FDealType, FOfferType } from '../../utils/category';
import { getRegionId, moscowMoIds, spbLoIds } from '../../utils/geo';

import { setTermValue } from './advanced/term';
import { jq } from '../../json_query/reducers';

export function changeIsDealRent(value: boolean) {
  return (dispatch: Dispatch) => {
    dispatch(setTermValue('deal_rent', value || undefined));
  };
}

const removeDealRentFilter = (state: IAppState): IAppState => ({
  ...state,
  filters: {
    ...state.filters,
    jsonQuery: {
      ...state.filters.jsonQuery,
      deal_rent: undefined,
    },
  },
});

export function dealRentReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type !== 'deal_rent') {
        return state;
      }

      return removeDealRentFilter(state);

    case 'filters/tags/ALL_TAGS_REMOVED':
      return removeDealRentFilter(state);

    case 'filters/deal_type/DEAL_TYPE_CHANGED':
      if (action.value & FDealType.RentLongterm) {
        return state;
      }

      const nextState = removeDealRentFilter(state);

      if (
        action.value & FDealType.Sale &&
        state.filters.jsonQuery.coworking_offer_type &&
        state.filters.jsonQuery.coworking_offer_type.value.length > 0
      ) {
        const jsonQuery = jq(state.filters.jsonQuery);

        return {
          ...nextState,
          filters: {
            ...nextState.filters,
            jsonQuery: jsonQuery.selectOfferType(FOfferType.Flat),
          },
        };
      }

      return nextState;

    case 'filters/offer_type/OFFER_TYPE_SELECTED':
      if (action.offerType & FOfferType.Flat) {
        return state;
      }

      return removeDealRentFilter(state);

    case 'filters/location_switcher/REGION_SELECTED':
      const region = getRegionId(action.region);
      if (region && [...moscowMoIds, ...spbLoIds, -1, -2].includes(region)) {
        return state;
      }

      return removeDealRentFilter(state);

    default:
      return state;
  }
}
